import _ from 'lodash';
import moment from 'moment';

export const ACTIVE_PLANS = {
  free: 'FREE1902',
  premium: [
    'PREMIUM2307M0_100',
    'PREMIUM2307M1_100',
    'PREMIUM2307M2_100',
    'PREMIUM2307M3_100',
    'PREMIUM2307M4_100',
    'PREMIUM2307M5_100',
    'PREMIUM2307M6_100',
  ],
  trial: 'TRIAL1902',
};

export default class SitePlan {
  constructor(plan) {
    this.plan = plan;
  }

  isFreeTrial() {
    return this.plan.plan_code.indexOf('TRIAL') !== -1;
  }

  isTrialPlan() {
    return ACTIVE_PLANS.trial === this.plan.plan_code;
  }

  isFreePlan() {
    return ACTIVE_PLANS.free === this.plan.plan_code;
  }

  isPlusPlan() {
    return ACTIVE_PLANS.plus === this.plan.plan_code;
  }

  isPremiumPlan() {
    return ACTIVE_PLANS.premium.indexOf(this.plan.plan_code) !== -1;
  }

  isLegacyPlan() {
    return !this.isFreePlan() &&
      !this.isPlusPlan() &&
      !this.isPremiumPlan() &&
      !this.isTrialPlan();
  }

  formatExpirationDate() {
    if (!this.plan.expiration) return moment().format('MMMM Do YYYY');
    return moment(this.plan.expiration).format('MMMM Do YYYY');
  }

  hasStripeSubscription() {
    return Boolean(this.plan.subscription_id);
  }

  // serializePlan serializes a plan to a string, for easy local identification
  // purposes.
  serializePlan(intervalArg) {
    let interval = _.get(this, 'plan.interval');
    if (!interval) interval = intervalArg;
    if (!interval) throw Error('no interval given to serializePlan');
    const modules = _.sortBy(_.get(this, 'plan.addon_modules'), (m) => m)
      .join();
    return `${this.plan.plan_code}${interval}${modules}`;
  }
}
